// Quotes.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Quotes() {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const testimonials = [
    {
      quote:
        "Talent is not just found — it’s understood, shaped, and aligned with purpose.",
      
    },
    {
      quote:
        "A strong company culture starts with hiring people who already reflect its future.",
      
    },
    {
      quote:
        "HR is no longer about filling roles — it’s about fueling results with the right people",
     
    },
  ];

  return (

    <div className="testimonial10 sp1">
        <div className="space70"></div>
       <div className="space70"></div>
      <div className="container">
        <div className="row align-items-center space-margin60">
          <div className="col-lg-12">
            <div class="title-box animate">
  <h1>WISDOM OF WORK</h1>
</div>
          </div>
          <div className="col-lg-4"></div>
    
        </div>

        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="testimonial7-images">
              
              <div className="img1">
                <img
                  src="assets/img/all-images/testimonial/Hr.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <Slider {...settings} className="testimonial7-contetnt-area">
              {testimonials.map((item, index) => (
                <div key={index} className="testimonial7-boxarea">
                  <div className="testimonial7-conetent">
                   
                   
                    <h2 >“{item.quote}”</h2>
                    <div className="space70"></div>
                    <div className="images-area">
                     
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
       <div className="space70"></div>
    </div>
  );
}

export default Quotes;
